import { localCatalog } from '../data/catalog'
import { policy } from '../data/policies'
import { kuurProductsFor } from '../data/kuurProducts'
import { DEFAULT_VAT_RATE, vatRateOf } from '../core/rules/revenue'
import { isKuurProductId } from '../core/rules/kuur'
import { vatCountryFor } from '../core/rules/vatCountry'
import type { AccountOrder } from '../core/types/account'
import type { OrderLineRequest } from '../core/types/requests'
import type { OrderLine } from './db'

/**
 * DEMO — prijzen vastleggen zoals de server het bij het plaatsen doet. Gebruikt door de shop-demo
 * (een nieuwe bestelling) en door het opbouwen van de voorbeelddata.
 */

export const productOf = (productId: string) =>
  [...localCatalog.products, ...localCatalog.giftCards, ...kuurProductsFor(localCatalog.treatments)].find((p) => p.id === productId)

export const isGiftCard = (productId: string) => localCatalog.giftCards.some((g) => g.id === productId)

/** Gaat niet op de post: cadeaubon of kuur. */
export const isDigital = (productId: string) => isGiftCard(productId) || isKuurProductId(productId)

/**
 * Prijs, btw-tarief en het land van dat tarief vastleggen op het moment van verkoop: een latere
 * wijziging verandert deze regel niet. `via` (huidadvies) gaat mee voor Inzicht.
 */
export const pricedLines = (lines: OrderLineRequest[], destination?: string): OrderLine[] =>
  lines.map((l) => {
    const p = productOf(l.productId)
    return {
      productId: l.productId,
      qty: l.qty,
      price: p?.price ?? 0,
      vatRate: p ? vatRateOf(p) : DEFAULT_VAT_RATE,
      vatCountry: vatCountryFor(destination),
      ...(l.via === 'huidadvies' ? { via: l.via } : {}),
    }
  })

/** Zelfde regel als de winkelmand: cadeaubonnen en abonnementen zonder verzendkosten. */
export function shippingFor(lines: AccountOrder['lines'], subscribe: boolean) {
  const products = lines.filter((l) => !isDigital(l.productId)).reduce((s, l) => s + l.price * l.qty, 0)
  return products === 0 || subscribe || products >= policy.freeShippingFrom ? 0 : policy.shippingCost
}
